import React from 'react';
import { FormattedMessage } from 'react-intl-next';
/**
 * Component that takes a string containing placeholders (i.e. `"{abc}"`) and replaces them with elements represented in
 * `templateVariables`.
 */
export default function FormattedText(_ref) {
  var text = _ref.text,
    values = _ref.values;
  // If text === '', FormattedMessage will return the id
  if (!text) {
    return null;
  }
  var templateMessage = {
    id: 'notificationList.templateText.no-translate',
    defaultMessage: text,
    values: values
  };
  return /*#__PURE__*/React.createElement(FormattedMessage, templateMessage);
}